import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Header from './containers/Header';
import PropertiesList from './containers/PropertiesList';

import { getProperties, getCoordinates, getTotalPrevision } from '../../reducers/propertiesSlice';

const AdvertsList = () => {
  const { baseCollection, collection, sortFilter } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCoordinates(baseCollection));
  }, [baseCollection]);

  useEffect(() => {
    dispatch(getProperties(Object.assign({}, baseCollection, sortFilter ? { sortFilter } : {})));
  }, [baseCollection, sortFilter]);

  useEffect(() => {
    dispatch(getTotalPrevision(collection));
  }, [collection]);

  return(
    <div>
      <Header />

      <PropertiesList />
    </div>
  )
};

export default AdvertsList;
